import {Module} from "vuex";

import {RootStateType} from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import {EventImplementationState} from "./model";

let state: EventImplementationState = {
  eventImplementations: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<EventImplementationState, RootStateType>;
